import React from "react";
import VlogList from "../VlogList/VlogList";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const VlogListCodeArchitecture = () => {
  const title = "ארכיטקטורת קוד";
  const description = `ברוכים הבאים למאגר הידע שלי על ארכיטקטורת קוד! כאן תמצאו אוסף מקיף של וולוגים שמעמיקים בעולם הארכיטקטורה של תוכנה. בכל וולוג נתמקד בנושא ספציפי, נבין את העקרונות והדפוסים העיקריים, ונראה דוגמאות מעשיות ליישום. בין אם אתם מפתחים מתחילים או מפתחים ותיקים, הוולוגים כאן יעזרו לכם להבין טוב יותר איך לתכנן ולבנות מערכות תוכנה איכותיות, מתוחזקות וסקלביליות.`;

  const vlogs = [
    {
      topic: "מערכת ניהול הרשאות משתמשים",
      vlogs: [
        {
          id: "CodeArchitecture/UserPermissionsManagement/Vlog1",
          name: "הכרות עם המערכת",
        },
        {
          id: "CodeArchitecture/UserPermissionsManagement/Vlog2",
          name: "איך הכל מתחבר",
        },
        {
          id: "CodeArchitecture/UserPermissionsManagement/Vlog3",
          name: "מבנה הפרויקט",
        },
      ],
    },
    {
      topic: "מערכת ניהול מלאי לחנות אונליין",
      vlogs: [
        {
          id: "CodeArchitecture/ECommerceInventory/Vlog1",
          name: "הכרות עם המערכת",
        },
        {
          id: "CodeArchitecture/ECommerceInventory/Vlog2",
          name: "איך הכל מתחבר",
        },
        {
          id: "CodeArchitecture/ECommerceInventory/Vlog3",
          name: "מבנה הפרויקט",
        },
      ],
    },
  ];

  return (
    <>
      <VlogList title={title} description={description} vlogs={vlogs} />
    </>
  );
};

export default VlogListCodeArchitecture;
